import React from 'react';
import { BuildsItemBreakdownViewModel } from '@resources/js/components/BuildsBestEnchantsSection/BuildsBestEnchantsSection';
import EnhancedMarkdown from '@resources/js/components/EnhancedMarkdown/EnhancedMarkdown';

// import type BuildsItemBreakdownViewModel and add a key of type integer
type BuildsItemBreakdownProps = BuildsItemBreakdownViewModel & {
  key: number;
  side: 'left' | 'right';
};

export default function BuildsItemBreakdown({
  slotLabel,
  bestLabel,
  itemMarkdown,
  iconMarkdown,
  popularityMarkdown,
  side,
}: BuildsItemBreakdownProps): JSX.Element {
  return (
    <div className={`builds-item-breakdown builds-item-breakdown--${side}`}>
      <div className={'builds-item-breakdown__icon'}>
        <EnhancedMarkdown markdown={iconMarkdown} wrapped={false} />
      </div>

      <div className={'builds-item-breakdown__item'}>
        <div className={'builds-item-breakdown__item-name'}>
          <EnhancedMarkdown markdown={itemMarkdown} wrapped={false} />
        </div>
        <div className={'builds-item-breakdown__item-description'}>
          <span className={'builds-item-breakdown__item-slot'}>
            {slotLabel}
          </span>
          {bestLabel && <span> - {bestLabel}</span>}
        </div>
      </div>

      <div className={'builds-item-breakdown__popularity'}>
        <EnhancedMarkdown markdown={popularityMarkdown} wrapped={false} />
      </div>
    </div>
  );
}
